"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPhotoClipImages = getPhotoClipImages;
exports.getPhotoClip = getPhotoClip;
exports.fillByHeight = fillByHeight;
exports.fillByWidth = fillByWidth;
exports.getFitCrop = getFitCrop;
exports.getFillCrop = getFillCrop;
exports.getPhotoCrop = getPhotoCrop;
exports.getDefaultVideoTransitionOnReplace = getDefaultVideoTransitionOnReplace;

var _ratioUtils = require("./ratio-utils");

const FIT = 'fit'; // const FILL = 'fill';
// return the photo image urls

function getPhotoClipImages(clip, blurImage, cropImage, cdn) {
  const images = [];
  const {
    crop,

    /* filter, */
    photo: {
      url
    }
  } = clip;
  const {
    width,
    height
  } = (0, _ratioUtils.getRatioObjectBy)('ratio', crop.aspectRatio);
  const blurUrl = blurImage(url, width, height, cdn);
  const cropUrl = cropImage(url, crop, width, height, cdn, undefined);
  images.push(blurUrl);
  images.push(cropUrl);
  return images;
} // return photo clip from photo object


function getPhotoClip(photo, startTime, duration, ratio, cropType, forceCut, animations, transitions) {
  const defaultDuration = 4;
  const maxDuration = 10;

  const animation = _.sample(animations.filter(obj => !obj.excludeFromDefault));

  let transition = _.sample(transitions.filter(obj => !obj.excludeFromDefault));

  if (startTime === 0 || forceCut) {
    transition = transitions.find(obj => obj.id === 'cut'); // cut transition
  }

  const transitionDuration = transition.inDuration / 1000;
  let startTimeStamp = startTime || 0;
  const endTimeStamp = duration === -1 ? startTimeStamp + defaultDuration : startTimeStamp + Math.min(duration, maxDuration);
  startTimeStamp = Math.max(startTimeStamp - transitionDuration, 0);
  const photoClip = {
    type: 'photo',
    crop: getPhotoCrop(photo, (0, _ratioUtils.getRatioObjectBy)('ratio', ratio), cropType),
    animation: {
      id: animation.id
    },
    timeline: {
      start: {
        timestamp: startTimeStamp,
        transition: transition.id,
        transitionDuration
      },
      end: {
        timestamp: endTimeStamp,
        transition: 'cut',
        transitionDuration: 0
      }
    }
  };
  photoClip.photo = photo;
  return photoClip;
} // return crop by width


function fillByWidth(ratio, w, h) {
  const crop = {
    x: 0,
    w
  };
  const height = Math.floor(w / ratio);
  crop.y = Math.floor((h - height) / 2);
  crop.h = height;
  return crop;
} // return crop by height


function fillByHeight(ratio, w, h) {
  const crop = {
    y: 0,
    h
  };
  const width = Math.floor(h * ratio);
  crop.x = Math.floor((w - width) / 2);
  crop.w = width;
  return crop;
} // retun photo crop fill


function getFillCrop(photo, aspectRatio) {
  const {
    w,
    h
  } = photo; // aspect ratio size

  const {
    width,
    height,
    ratio
  } = aspectRatio;
  const viewPortRatio = width / height;
  const photoRatio = w / h;
  let fillFunction;

  if (viewPortRatio === 1) {
    if (photoRatio >= viewPortRatio) {
      fillFunction = fillByHeight;
    } else {
      fillFunction = fillByWidth;
    }
  } else if (viewPortRatio > 1) {
    if (photoRatio > viewPortRatio) {
      fillFunction = fillByHeight;
    } else {
      fillFunction = fillByWidth;
    }
  } else if (photoRatio < viewPortRatio) {
    fillFunction = fillByWidth;
  } else {
    fillFunction = fillByHeight;
  }

  const crop = { ...fillFunction(viewPortRatio, w, h),
    aspectRatio: ratio
  };
  return crop;
}

function getFitCrop(photo, aspectRatio) {
  const {
    ratio
  } = aspectRatio;
  return {
    x: 0,
    y: 0,
    w: photo.w,
    h: photo.h,
    aspectRatio: ratio
  };
} // return photo crop by crop type fill or fit


function getPhotoCrop(photo, aspectRatio, cropType) {
  if (cropType === FIT) {
    // return fit crop
    return getFitCrop(photo, aspectRatio);
  } // return fill crop


  return getFillCrop(photo, aspectRatio);
}

function getDefaultVideoTransitionOnReplace(timeline) {
  const newTimeline = { ...timeline
  };
  const {
    transition
  } = newTimeline.start;

  if (transition !== 'fade' && transition !== 'cut') {
    newTimeline.start.transition = 'fade';
  }

  return timeline;
}